import CertificateType from 'components/reusables/certificateType'
import { Wrapper } from './styled'

interface IProps {
  value: string,
  certificateType: number
}

const Title = ({ value, certificateType }: IProps) => {
  return <Wrapper>
    {value} <CertificateType value={certificateType}/>
  </Wrapper>
}

export default Title
